import React from "react";
import { TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Pencil } from "lucide-react";
import DocumentStatusPopover from "../DocumentStatusPopover";
import { estadoColores } from "../ListadoSolicitud.constants";

// Columna "Cédula": número de cédula, botón de observación de crédito (si hay
// permiso) y el botón de "Observaciones" que abre el popover de estado.
export default function CeldaCedula({
  data,
  permisoAgregarObservacionCredito,
  handleOpenObservacionCredito,
  handlePopoverOpen,
  popoverData,
  handlePopoverClose,
  clienteEstados,
}) {
  return (
    <TableCell align="center" className="relative">

      <div className="flex flex-col items-center justify-start h-[60px]">
        <span className="text-gray-800 font-normal mb-2">{data.cedula}</span>


        <div className="flex items-center justify-end w-full space-x-1">
          {permisoAgregarObservacionCredito() && (
            <button
              onClick={() => handleOpenObservacionCredito(data)}
              title="Observación de Crédito"
              className="flex items-center justify-center h-6 w-6 rounded-full
                   bg-white shadow-sm hover:bg-blue-50 hover:shadow-md
                   transition-all duration-200 border border-gray-200"
            >
              <Pencil className="text-[#050771] w-4 h-4" />
            </button>
          )}


          <button
            onClick={(event) => handlePopoverOpen(event, 10, data)}
            title="Observaciones"
            className="flex items-center justify-center h-6 w-6 rounded-full
                   hover:bg-gray-100 transition-colors duration-200"
          >
            <MoreVertIcon className="text-slate-400 hover:text-slate-600 transition-colors duration-200 w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Popover de estado */}
      <DocumentStatusPopover
        open={popoverData.open && popoverData.selectedRowId === data.id}
        anchorEl={popoverData.anchorEl}
        onClose={handlePopoverClose}
        clienteEstados={clienteEstados}
        estadoColores={estadoColores}
      />
    </TableCell>
  );
}
